import { apiGet, apiPost } from './resources/apiActions/apiRequest';
import { getValue } from '../util/injector';
import { GATEWAY_CONTENT_AUTH, GATEWAY_CONTENT_V2, GATEWAY_CONTENT_V3 } from '../data/Injectables';

export const getAntiForgeryToken = () => () =>
  getValue(GATEWAY_CONTENT_V2).get('/aft', null, {
    credentials: 'include',
  });

export const SEND_CONTACT = 'contactActions/SEND_CONTACT';
export const FETCH_SUBJECT_OPTIONS = 'contactActions/FETCH_SUBJECT_OPTIONS';

const sendContact = values => dispatch =>
  dispatch(getAntiForgeryToken()).then(result =>
    dispatch(
      apiPost(SEND_CONTACT, GATEWAY_CONTENT_V3, '/contact', values, {
        headers: {
          // eslint-disable-next-line no-underscore-dangle
          'X-XSRF-Token': result.data.__RequestVerificationToken,
        },
        credentials: 'include',
      }),
    ),
  );

export const fetchSubjectOptions = () => dispatch =>
  dispatch(getAntiForgeryToken()).then(result =>
    dispatch(
      apiGet(FETCH_SUBJECT_OPTIONS, GATEWAY_CONTENT_AUTH, '/contact-reasons', {
        headers: {
          // eslint-disable-next-line no-underscore-dangle
          'X-XSRF-Token': result.data.__RequestVerificationToken,
        },
        credentials: 'include',
      }),
    ).then(({ data }) => data),
  );

export default sendContact;
